import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ClaimListComponent from "./modules/claimListNew";
import ClaimListHistory from "./modules/claimList";
import PrivateRoute from "./privateRoute";
import ClaimDetailsComponent from "./modules/claimDetails";
import ClaimDetailsComponentNew from "./modules/claimDetailsNew";
import OktaLogin from "./modules/login";
import ClaimReportComponent from "./modules/claimReport";
import ReportListComponent from "./modules/reportListNew";
import RepairFirstComponent from "./modules/repairFirst";
import CommercialUsageComponent from "./modules/commercialUsage";
import CommercialList from "./modules/commercialList";
import AIReviewClaimList from "./modules/AIReviewClaimList";
import AIReviewClaimDetails from "./modules/AIReviewClaimDetails";
import AIReportListComponent from "./modules/AIReviewReport";
// import RepairFirstComponentDetails from "./modules/RepairFirstDetails";
import RepairList from "./modules/RepairFirstClaim";

const Router = () => {
  return (
    <Routes>
      <Route path="/" element={<OktaLogin />} />
      <Route
        path="/claim-list"
        element={<PrivateRoute element={ClaimListComponent} />}
      />
      <Route
        path="/claim-history"
        element={<PrivateRoute element={ClaimListHistory} />}
      />
      <Route
        path="/claim/:claimNumber/:version/"
        element={
          <PrivateRoute element={ClaimDetailsComponent} bg={"bg-grey-40"} />
        }
      />
      <Route
        path="/claim-record/:claimNumber/:version/"
        element={
          <PrivateRoute element={ClaimDetailsComponentNew} bg={"bg-grey-40"} />
        }
      />
      <Route
        path="/repair-report"
        element={<PrivateRoute element={RepairFirstComponent} />}
      />
      {/* <Route
        path="/repair-first/:claimNumber/:version/"
        element={
          <PrivateRoute
            element={RepairFirstComponentDetails}
            bg={"bg-grey-40"}
          />
        }
      /> */}
      <Route
        path="/repair-claims"
        element={<PrivateRoute element={RepairList} />}
      />
      <Route
        path="/claim-report"
        element={<PrivateRoute element={ClaimReportComponent} />}
      />
      <Route
        path="/report-list"
        element={<PrivateRoute element={ReportListComponent} />}
      />
      <Route
        path="/commercial-report"
        element={<PrivateRoute element={CommercialUsageComponent} />}
      />
      <Route
        path="/commercial-list"
        element={<PrivateRoute element={CommercialList} />}
      />
      <Route
        path="/inspection-claims"
        element={<PrivateRoute element={AIReviewClaimList} />}
      />
      <Route
        path="/inspection-claims/:claimNumber"
        element={
          <PrivateRoute element={AIReviewClaimDetails} bg={"bg-grey-40"} />
        }
      />
      <Route
        path="/inspection-claims/report"
        element={<PrivateRoute element={AIReportListComponent} />}
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default Router;
